module.exports = __webpack_public_path__ + "static/media/red_inf.66f77425.svg";